<script setup>
import { onMounted, computed } from 'vue';
import { useObterTotalSolicitacoesCdiPorUsuario } from '~/composables/compromissos/useObterTotalSolicitacoesCdiPorUsuario';
import { colors } from '~/utils';

const {
  status: obterTotalSolicitacoesCdiPorUsuarioStatus,
  data: obterTotalSolicitacoesCdiPorUsuarioData,
  runAsync: obterTotalSolicitacoesCdiPorUsuarioAsync,
} = useObterTotalSolicitacoesCdiPorUsuario();

const chartOptions = computed(() => {
  if (obterTotalSolicitacoesCdiPorUsuarioStatus.value !== 'success') {
    return null;
  }
  return {
    chart: {
      type: 'bar',
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      animations: {
        enabled: false,
      },
    },
    colors,
    plotOptions: {
      bar: {
        distributed: true,
      },
    },
    series: [
      {
        name: 'total',
        data: obterTotalSolicitacoesCdiPorUsuarioData.value.items.map(
          (x) => x.total
        ),
      },
    ],
    xaxis: {
      categories: obterTotalSolicitacoesCdiPorUsuarioData.value.items.map(
        (x) => x.usuario
      ),
      labels: {
        show: false,
      },
    },
  };
});

onMounted(async () => {
  await obterTotalSolicitacoesCdiPorUsuarioAsync();
});
</script>

<template>
  <ChartCard
    :status="obterTotalSolicitacoesCdiPorUsuarioStatus"
    :options="chartOptions"
  >
    <template #title>
      <span style="color: rgb(128 128 128); font-size: 16px"
        >TOTAL DE SOLICITAÇÕES POR USUÁRIO</span
      >
    </template>
  </ChartCard>
</template>
